module.exports = __webpack_public_path__ + "static/img/right-arrow-triangle.76d2b5f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/right-arrow-triangle.svg
// module id = cAVt
// module chunks = 4